import { render, staticRenderFns } from "./Hacienda.vue?vue&type=template&id=06bcddd2&scoped=true"
import script from "./Hacienda.vue?vue&type=script&lang=js"
export * from "./Hacienda.vue?vue&type=script&lang=js"
import style0 from "./Hacienda.vue?vue&type=style&index=0&id=06bcddd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bcddd2",
  null
  
)

export default component.exports